import { createActions } from 'redux-actions';

export const { setLegacyAccounts } = createActions('SET_LEGACY_ACCOUNTS');
export const { setOrganizations } = createActions('SET_ORGANIZATIONS');
